import { ToastContainer } from "react-toastify";

export const ToasterContainer = () => {
  return (
    <ToastContainer
      draggable
      autoClose={2000}
      closeOnClick={true}
      position="top-center"
      pauseOnFocusLoss={false}
    />
  );
};
